<template>
  <div>
    <!-- context field-->
    <v-row>
      <v-switch
        v-model="facetNewValue.hasContext"
        :disabled="isDisabled"
        class="mx-3"
        label="Contexte(s) de recherche"
        color="success"
        hide-details
      />
    </v-row>

    <!-- field of context -->
    <v-row no-gutters class="mx-3">
      <v-col cols="9">
        <v-text-field
          v-if="facetNewValue.hasContext"
          v-model="facetNewValue.values"
          :error="error"
          :rules="[isValid]"
          label="Définir un contexte utilisateur"
          item-color="info"
          menu-props="light"
          color="blue"
          clearable
        />
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
import { ref, watch, computed } from 'vue';

const props = defineProps({ condition: { type: Object, default: null }, isDisabled: { type: Boolean, default: false } });
const emit = defineEmits('update:condition');

const facetNewValue = ref(props.condition);

const isValid = computed(() => {
  if (!facetNewValue.value.values) {
    return 'Required';
  }

  if (
    facetNewValue.value.values
    && !facetNewValue.value.values.match(/^[0-9a-zA-Z_-]+$/)
  ) {
    return 'Pas de caractère alphanumérique';
  }

  if (
    facetNewValue.value.values
    && facetNewValue.value.values.match(/[A-Z]+$/)
  ) {
    return 'Pas de majuscules';
  }

  return true;
});

// To show error on page load
const error = computed(() => typeof isValid.value === 'string' || !isValid.value);

watch(
  () => facetNewValue.value,
  () => {
    // Updates v-model on the parent
    emit('update:condition', facetNewValue.value);
  },
  { deep: true }
);

</script>

<style>
</style>
